import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProfileDTO } from '../model/user-profiles-model';
import { UserProfilesStore } from '../user-profiles-service/user-profiles-service.store';
import { InfoDialog } from '@shared/dialogs/info/info.component';
import { TranslateService } from '@ngx-translate/core';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {
  public showAttributions: boolean = false;
  public profileToUpdate: ProfileDTO;

  constructor(
    private userProfilesStore: UserProfilesStore,
    private dialog: MatDialog,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {}

  viewAttributions(profile: ProfileDTO) {
    if (profile) {
      this.profileToUpdate = profile;
      this.showInformationDialog();
    }
  }

  updateProfile(selectionProfile: ProfileDTO) {
    this.userProfilesStore.updateProfile(selectionProfile).subscribe(
      (result) => {
        if (result) {
          this.showAttributions = false;
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '550px';
          dialogConfig.data = {
            text: this.translateService.instant('dialog.updateProfiles.response.success'),
            icon: 'icon-ic_circle_check',
            noRedirect: true,
          };
          setTimeout(() => {
            window.scrollTo(0, 0);
            this.dialog.open(ResponseDialogComponent, dialogConfig);
          }, 0);
        }
      },
      (error) => {
        console.log(error);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '450px';
        dialogConfig.data = {
          text: this.translateService.instant('dialog.updateProfiles.response.error').toUpperCase(),
          icon: 'icon-ic_circle_cross',
          noRedirect: true,
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  showInformationDialog(): boolean {
    let isAccepted: boolean = false;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      text: this.translateService.instant('dialog.updateProfiles.infoDialog'),
    };
    const dialogRef = this.dialog.open(InfoDialog, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (result) => {
        this.showAttributions = result;
      },
      (error) => console.error(error)
    );
    return isAccepted;
  }
}
